import { Project } from "../entities/project";
import { ProjectUser } from "../entities/project-user";
import { ProjectDTO } from "../dtos/project.dto";
import { ProjectUserDTO } from "../dtos/project-user.dto";

export class ProjectMapper {
  static toDTO(project: Project): ProjectDTO {
    return {
      id: project.id,
      name: project.name,
      description: project.description,
      inviteCode: project.invite_code,
      createdById: project.created_by_id,
      createdAt: project.created_at,
      updatedAt: project.updated_at,
      onboarding_completed_at: project.onboarding_completed_at,
    };
  }

  static toProjectUserDTO(projectUser: ProjectUser | any): ProjectUserDTO {
    return {
      id: projectUser.id,
      projectId: projectUser.project_id,
      userId: projectUser.user_id,
      role: projectUser.role,
      joinedAt: projectUser.joined_at,
      user: projectUser.users
        ? {
            id: projectUser.users.id,
            name: projectUser.users.full_name,
            email: projectUser.users.email,
            avatar_url: projectUser.users.avatar_url,
          }
        : undefined,
    };
  }
}

